import { Cpu64BitIcon } from './Cpu64BitIcon';

/**
 * author: GreenTurtwig
 * id BC47ABAD-66D6-4EEA-9512-CB33318F62EF
 * name cpu-64-bit
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cpu-64-bit.svg
 * tags
 */
export const Chip64BitIcon = Cpu64BitIcon;
export default Chip64BitIcon